import { Routes } from '@angular/router';
import { CONTACT_US_PATH } from '@woolworthsnz/shop';
import { ContactUsPage } from './pages/contact-us/contact-us.page';

export const routes: Routes = [
	{
		path: CONTACT_US_PATH,
		component: ContactUsPage,
	},
];
